import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function HomeNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleJump = (id: string) => {
    setOpen(false);
    const target = document.getElementById(id);
    if (target) {
      const top = target.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200/80'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className={`flex items-center gap-2 cursor-pointer transition-colors ${
            scrolled ? 'text-foreground-950' : 'text-background-50'
          }`}
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-movie-2-line text-base" />
          </span>
          <span className="font-heading text-base md:text-lg font-bold tracking-tight whitespace-nowrap">
            蜜桃成熟时3D
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <button
              key={link.id}
              type="button"
              onClick={() => handleJump(link.id)}
              className={`px-3 py-2 text-[13px] font-label rounded-md whitespace-nowrap cursor-pointer transition-colors ${
                scrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => handleJump('overview')}
            className={`hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-[13px] font-label whitespace-nowrap cursor-pointer transition-colors ${
              scrolled
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-background-50 text-foreground-950 hover:bg-background-100'
            }`}
          >
            <i className="ri-bookmark-line" />
            开始阅读
          </button>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setOpen((v) => !v)}
            className={`lg:hidden w-9 h-9 flex items-center justify-center rounded-md cursor-pointer ${
              scrolled ? 'text-foreground-950 bg-background-100' : 'text-background-50 bg-background-50/15'
            }`}
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-3 grid grid-cols-2 gap-2">
          {navLinks.map((link) => (
            <button
              key={link.id}
              type="button"
              onClick={() => handleJump(link.id)}
              className="px-3 py-2.5 text-sm font-label text-foreground-800 bg-background-100 rounded-md text-left cursor-pointer hover:bg-primary-50 hover:text-primary-700 transition-colors"
            >
              {link.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}